import React from 'react';
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

export default function SpecialistMainAreasOfInterestDialog({
  open,
  content,
  onContinue,
  onCancel,
}) {
  const areas = (content || '')
    .split(/\r?\n/)
    .map((area) => area.trim())
    .filter(Boolean);

  return (
    <Dialog open={open}>
      <DialogContent
        showCloseButton={false}
        onEscapeKeyDown={(event) => event.preventDefault()}
        onPointerDownOutside={(event) => event.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Pagrindinės domėjimosi sritys</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="max-h-[50vh] overflow-y-auto text-left">
            <ul
              className="space-y-2"
              style={{ listStyleType: 'disc', paddingLeft: '1.25rem' }}
            >
              {areas.map((area, index) => (
                <li key={`${index}-${area}`}>{area}</li>
              ))}
            </ul>
          </div>
        </DialogBody>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            Atšaukti
          </Button>
          <Button onClick={onContinue}>Susipažinau ir tęsti</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
